import { useState } from 'react'
import { FormContainerUserSignUp, FormTitle, InputFlex, Label, StyledInput, InputGrid, InputDiv, FormInfo, Details, FormLink, Reveal } from '../../../reusable_ui/styles/Forms.styled' 
import { LogoImg } from '../../NavPage/styles/NavPage.styled'
import { SignUpFormControl} from '../../../pages/SignUp/User/styles/SignUp.user.styled'
import { InputButton } from '../../../reusable_ui/styles/Button.styled'


const UserSignUp = () => {
  const[password, setPassword] = useState('password')
  const[type, setType] = useState(true)
  const[id, setId] = useState('')
  const[visible, setVisible] = useState(true)

  const CurrentType = type ? 'password' : 'text';
  const Visibility = visible ? '' : 'unreveal'

  const onReveal = () => {
    setPassword(CurrentType)
    setType(!type)
    setId(Visibility)
    setVisible(!visible)
  }



  return (
    <FormContainerUserSignUp>
      <LogoImg />
      <SignUpFormControl>
        <FormTitle>
          <span>Create your Account</span>
          <p>Fill the form below to set up your account.</p>
        </FormTitle>
        <InputFlex>
          <InputGrid>
            <Label>First name</Label>
            <StyledInput  type="text" placeholder='' />
          </InputGrid>
          <InputGrid>
            <Label>Last name</Label>
            <StyledInput  type="text" placeholder=''/>
          </InputGrid>
        </InputFlex>
        <InputDiv>
          <Label>Email address</Label>
          <StyledInput type='email' />
        </InputDiv>
        <InputDiv>
          <Label>Phone number</Label>
          <StyledInput type='tel' />
        </InputDiv>
        <InputDiv>
          <Label>Password</Label>
          <StyledInput password type={password} />   
          <Reveal id={id} onReveal={onReveal} />       
        </InputDiv>
        
        <InputButton>Complete-Sign Up</InputButton>
        <FormInfo>
          <Details>Already have an account? <FormLink to='/user/login'>Login</FormLink></Details>
        </FormInfo>
      </SignUpFormControl>
    </FormContainerUserSignUp>
  )
}

export default UserSignUp


